export default __webpack_public_path__ + "static/media/m-slide-3.c4ef6ee2.png";